/** Single source for the area-of-concern color (editor, viewer and PNG graphic). */
export const DEFAULT_HIGHLIGHT = '#ff5a36';

export function normalizeHighlightColor(value?: string | null) {
  return value && /^#([0-9a-fA-F]{6})$/.test(value) ? value : DEFAULT_HIGHLIGHT;
}